import React from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

function CriterionValueGroup({ criterion, selectedValueIds, setSelectedValueIds }) {
  const handleToggleCV = (cvId) => {
    if (selectedValueIds.includes(cvId)) {
      setSelectedValueIds(selectedValueIds.filter((id) => id !== cvId));
    } else {
      setSelectedValueIds([...selectedValueIds, cvId]);
    }
  };

  const selectedCount = criterion.values.filter(cv => selectedValueIds.includes(cv.id)).length;
  const hasSelections = selectedCount > 0;

  return (
    <div style={{
      background: hasSelections ? 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)' : '#fff',
      border: hasSelections ? '1px solid #86efac' : '1px solid #e2e8f0',
      borderRadius: '8px',
      marginBottom: '12px',
      padding: '12px 16px',
      transition: 'all 0.2s ease',
      boxShadow: hasSelections ? '0 2px 8px rgba(34, 197, 94, 0.15)' : '0 1px 3px rgba(0,0,0,0.05)'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '10px'
      }}>
        <h5 style={{
          margin: 0,
          fontSize: '0.95em',
          fontWeight: '600',
          color: '#1e293b'
        }}>
          {criterion.name}
        </h5>
        {hasSelections && (
          <span style={{
            background: '#22c55e',
            color: '#fff',
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '0.7em',
            fontWeight: '600'
          }}>
            {selectedCount} selected
          </span>
        )}
      </div>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px'
      }}>
        {criterion.values.map((cv) => {
          const isChecked = selectedValueIds.includes(cv.id);
          return (
            <div
              key={cv.id}
              onClick={() => handleToggleCV(cv.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 12px',
                borderRadius: '6px',
                cursor: 'pointer',
                background: isChecked ? '#dcfce7' : '#f8fafc',
                border: isChecked ? '1px solid #22c55e' : '1px solid #e2e8f0',
                transition: 'all 0.15s ease',
                userSelect: 'none'
              }}
              onMouseEnter={(e) => {
                if (!isChecked) {
                  e.currentTarget.style.background = '#f1f5f9';
                  e.currentTarget.style.borderColor = '#cbd5e1';
                }
              }}
              onMouseLeave={(e) => {
                if (!isChecked) {
                  e.currentTarget.style.background = '#f8fafc';
                  e.currentTarget.style.borderColor = '#e2e8f0';
                }
              }}
            >
              {isChecked ? (
                <CheckBoxIcon sx={{ fontSize: 18, color: '#22c55e' }} />
              ) : (
                <CheckBoxOutlineBlankIcon sx={{ fontSize: 18, color: '#94a3b8' }} />
              )}
              <span style={{
                fontSize: '0.85em',
                color: isChecked ? '#166534' : '#475569',
                fontWeight: isChecked ? '500' : '400'
              }}>
                {cv.value}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CriterionValueGroup;
